import type { HubMetricConfig } from "@expert/app-config";

export const EMPTY_HUB_METRICS: HubMetricConfig[] = [];
